import dining from '@/assets/icon/category/dining.svg';
import cafe from '@/assets/icon/category/cafe.svg';
import fashion from '@/assets/icon/category/fashion.svg';
import retail from '@/assets/icon/category/retail.svg';
const findCategoryIcon = (category: string) => {
  switch (category) {
    case '21':
      return dining;
    case '22':
      return cafe;
    case '23':
      return fashion;
    case '24':
      return retail;
    default:
      return retail;
  }
};

export default findCategoryIcon;
